import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageTitle: {
    id: 'studio.Lv0zJu',
    defaultMessage: 'Details',
  },
  title: {
    id: 'studio.nTCcNg',
    defaultMessage: '{resourceName} details',
  },
  endpoints: {
    id: 'studio.cQyKR1',
    defaultMessage: 'Endpoints',
  },
  properties: {
    id: 'studio.aI80kg',
    defaultMessage: 'Properties',
  },
  description: {
    id: 'studio.4x5dbg',
    defaultMessage:
      'In order to access any of the endpoints of the <apiLink>API</apiLink> for this resource, unless the resource is marked as {public}, you must make sure each request is provided with an access token as described <securityLink>here</securityLink>.',
  },
});
